import Button from "Components/Button";
import { useApplicationActionMutation } from "hooks/CreditManagement/useApplicationActionMutation";
import { useParams } from "react-router-dom";
import { queryClient } from "services/queryClient";

const ApproveInterface = ({ setIsAddModalOpen }: any) => {
  const { id } = useParams();
  const { mutateAsync, isPending } = useApplicationActionMutation();

  const handleSubmit = () => {
    mutateAsync(
      { applicationId: id, type: "approve" },
      {
        onSuccess: () => {
          setIsAddModalOpen(false);
          queryClient.invalidateQueries({
            queryKey: ["getSingleCreditApplication"],
          });
        },
      }
    );
  };

  return (
    <div>
      <p className="text-primary-foreground text-lg">
        Are you sure you want to approve this application, this action can not
        be reversed
      </p>

      <div className="flex space-x-2 mt-3">
        <Button
          label="Yes"
          isLoading={isPending}
          onClick={() => handleSubmit()}
        />
        <Button
          label="No"
          onClick={() => setIsAddModalOpen(false)}
          className="bg-[#E8E8E8] text-[#2E2E2E]"
        />
      </div>
    </div>
  );
};

export default ApproveInterface;
